import BasketMsg from 'components/Basket/BasketMsg/BasketMsg';
import withBasketMsgProps from 'viewModel/basket/basketMsg/withBasketMsgProps';

export default withBasketMsgProps(BasketMsg);
